// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_DhIZj {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/analytics/views/Table.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B","sourcesContent":[".table {\n  overflow: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_DhIZj`
};
export default ___CSS_LOADER_EXPORT___;
